/* eslint-disable no-restricted-globals */
import micromodalOptions from '../lib/micromodal-options.js';

class LoginModal {
  constructor(element, open = false) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.close = element.querySelector('.modal__close');
    this.content = element.querySelector('.modal__container');
    this.overlay = element.querySelector('.modal__overlay');

    if (open) {
      MicroModal.show(this.element.id);
    }

    if (window.location.hash === `#${element.id}`) {
      MicroModal.show(this.element.id);
    }

    this.init();
  }

  init() {
    // get account modal toggles
    (document.querySelectorAll('.login-modal-toggle') ?? []).forEach((el) => {
      el.addEventListener('click', () => {
        window.dispatchEvent(new CustomEvent('login.resetSuccessUrl'));
        MicroModal.show(this.element.id, micromodalOptions);
      });
    });

    window.addEventListener('login.open', (e) => {
      MicroModal.show(this.element.id, micromodalOptions);
    });
  }

  closeModal() {
    MicroModal.close(this.element.id);
  }
}

export default LoginModal;
